export type RewardsPaneOpenOrigin = "tip" | "medallion" | "other";

const pendingOriginByAccount = new Map<string, RewardsPaneOpenOrigin>();

export function setRewardsPaneOpenOrigin(accountKey: string, origin: RewardsPaneOpenOrigin): void {
    if (!accountKey || pendingOriginByAccount.get(accountKey) === "tip") {
        return;
    }
    
    pendingOriginByAccount.set(accountKey, origin);
}

export function consumeRewardsPaneOpenOrigin(accountKey: string): RewardsPaneOpenOrigin {
    const origin = pendingOriginByAccount.get(accountKey) ?? "other";
    pendingOriginByAccount.delete(accountKey);
    return origin;
}
